module.exports = __webpack_public_path__ + "static/media/side_menu_logo.7d77ba06.svg";